export default __webpack_public_path__ + "static/media/trackYourReading@2x.8c4525c2.png";